import { StockService } from './../stock.service';
import { Component, Injector } from '@angular/core';
import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
import { Stock } from '../stock.model';

@Component({
    selector: 'ng-stock',
    templateUrl: 'stock-list.component.html',
    styleUrls: ['stock-list.component.css']
})

export class StockComponent extends BaseListComponent<Stock> {
    protected initChildMethods(): void {}
    protected initChildProprieties(): void {}

    constructor(
        public stockServ: StockService,
        public injector: Injector
      ) {
        super(stockServ,injector,'stock',{createUrl:'/admin/stock/new',editUrl:'/admin/stock/edit',detailUrl:'/admin/stock/detail'});
       }
       
    protected tableProprieties(): string[] {
        return [
            'Produto',
            'Código', 
            'Preço',
            'Stock', 
            'Status'
        ];
    }
}